import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TextWithIcon } from '@/ui';
import { translateChatMessage } from '@ngsos/portal-core/commands';

export type TranslatedChatPartComponentProps = {
  message: string | null;
  translateChat: boolean;
};

export function TranslatedChatPartComponent({ message, translateChat }: TranslatedChatPartComponentProps) {
  const { t, i18n } = useTranslation();
  const [translatedMessage, setTranslatedMessage] = useState<string | null>(null);
  const messageSnapshotRef = useRef<string | null>(null);

  const language = i18n.language || 'en';

  useEffect(() => {
    if (!translateChat) {
      return;
    }
    if (messageSnapshotRef.current === message) {
      return;
    }
    if (message === null || message.trim() === '') {
      return;
    }

    let cancelled = false;
    const targetCulture = language.split('-')[0] ?? 'en';
    void translateChatMessage(message, targetCulture)
      .then((translated) => {
        if (!cancelled) {
          setTranslatedMessage(translated);
          messageSnapshotRef.current = message;
        }
      })
      .catch((error: unknown) => {
        console.error('Chat translation failed. ' + String(error));
      });

    return () => {
      cancelled = true;
    };
  }, [translateChat, message, language]);

  if (!translateChat) {
    return null;
  }

  return (
    <div className="border-top border-1 border-black border-opacity-50 mt-1">
      <div className="x-small text-muted mt-1">
        <TextWithIcon icon="fal fa-language" text={t('Chat_AutomaticTranslation')} />
      </div>
      <div>{translatedMessage}</div>
    </div>
  );
}
